import React, { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Menu } from "semantic-ui-react";
import { useSelector } from "react-redux";

const Footer = (props) => {
  const selectorState = useSelector((state) => state);
  const bottomTabFlag = selectorState.commonActionsReducer.hideHeader;
  const bottomTabFlagFooter = selectorState.commonActionsReducer.hideFooter;
  const [activeItem, setActiveItem] = useState("summary");

  const handleItemClick = (e, { name }) => {
    const permissions = props.session.data.permissions;
    setActiveItem(name);

    const navigationMap = {
      bookings: {
        path: "/bookings",
        condition: permissions.uep_view_bookings === "1",
      },
      inventory: {
        path: "/inventory-home",
        condition: permissions.uep_user_rate_access !== "na",
      },
      profile: {
        path: "/profile",
        condition: permissions.uep_hotel_profile === "1",
      },
      summary: {
        path: "/summary",
        condition: permissions.uep_hotel_profile === "1",
      },
    };

    const selectedNav = navigationMap[name];
    if (selectedNav?.condition) {
      props.history.push(selectedNav.path);
    } else {
      props.history.push("/unauthorized");
    }
  };

  useEffect(() => {
    const path = props.history.location.pathname;
    const pathMapping = [
      {
        key: "inventory",
        match: ["/inventory-home", "inventory", "/holida-inventory"],
      },
      { key: "bookings", match: ["/bookings"] },
      { key: "profile", match: ["/profile"] },
      { key: "summary", match: ["/summary", "/"] },
    ];

    const matched = pathMapping.find((item) =>
      item.match.some((route) => path === route)
    );

    setActiveItem(matched?.key || "");
  }, [props.history.location]);

  const renderSvgIcon = (name) => {
    const isActive = activeItem === name;
    const fillColor = isActive ? "#5F1CCC" : "#818181";

    const icons = {
      summary: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="24"
          viewBox="0 0 20 24"
          fill="none"
        >
          <path
            d="M12 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V23C0 23.2652 0.105357 23.5196 0.292893 23.7071C0.48043 23.8946 0.734784 24 1 24H19C19.2652 24 19.5196 23.8946 19.7071 23.7071C19.8946 23.5196 20 23.2652 20 23V8H13C12.7348 8 12.4804 7.89464 12.2929 7.70711C12.1054 7.51957 12 7.26522 12 7V0ZM3.5 17H16.5C16.6326 17 16.7598 17.0527 16.8536 17.1464C16.9473 17.2402 17 17.3674 17 17.5V18.5C17 18.6326 16.9473 18.7598 16.8536 18.8536C16.7598 18.9473 16.6326 19 16.5 19H3.5C3.36739 19 3.24021 18.9473 3.14645 18.8536C3.05268 18.7598 3 18.6326 3 18.5V17.5C3 17.3674 3.05268 17.2402 3.14645 17.1464C3.24021 17.0527 3.36739 17 3.5 17ZM3.5 12H16.5C16.6326 12 16.7598 12.0527 16.8536 12.1464C16.9473 12.2402 17 12.3674 17 12.5V13.5C17 13.6326 16.9473 13.7598 16.8536 13.8536C16.7598 13.9473 16.6326 14 16.5 14H3.5C3.36739 14 3.24021 13.9473 3.14645 13.8536C3.05268 13.7598 3 13.6326 3 13.5V12.5C3 12.3674 3.05268 12.2402 3.14645 12.1464C3.24021 12.0527 3.36739 12 3.5 12ZM8.5 9H3.5C3.36739 9 3.24021 8.94732 3.14645 8.85355C3.05268 8.75979 3 8.63261 3 8.5V7.5C3 7.36739 3.05268 7.24021 3.14645 7.14645C3.24021 7.05268 3.36739 7 3.5 7H8.5C8.63261 7 8.75979 7.05268 8.85355 7.14645C8.94732 7.24021 9 7.36739 9 7.5V8.5C9 8.63261 8.94732 8.75979 8.85355 8.85355C8.75979 8.94732 8.63261 9 8.5 9Z"
            fill={fillColor}
          />
          <path d="M19.414 6H14V0.585999L19.414 6Z" fill={fillColor} />
        </svg>
      ),
      bookings: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="21"
          viewBox="0 0 24 21"
          fill="none"
        >
          <path
            d="M20.7918 4.16846H3.37502C2.06333 4.16846 1 5.23179 1 6.54348V17.6269C1 18.9386 2.06333 20.0019 3.37502 20.0019H20.7918C22.1035 20.0019 23.1668 18.9386 23.1668 17.6269V6.54348C23.1668 5.23179 22.1035 4.16846 20.7918 4.16846Z"
            fill={fillColor}
            stroke={fillColor}
            stroke-width="1.5"
            stroke-linejoin="round"
          />
          <path
            d="M6.53906 4.16669V2.58335C6.53906 2.16342 6.70588 1.76069 7.00281 1.46375C7.29975 1.16682 7.70248 1 8.12241 1H16.0391C16.4591 1 16.8618 1.16682 17.1587 1.46375C17.4557 1.76069 17.6225 2.16342 17.6225 2.58335V4.16669"
            stroke={fillColor}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M23.1668 10.4567C23.581 10.4567 23.9168 10.1209 23.9168 9.70667C23.9168 9.29245 23.581 8.95667 23.1668 8.95667V10.4567ZM1 8.95667H0.25V10.4567H1V8.95667ZM16.224 10.0476C16.224 9.63341 15.8882 9.29762 15.474 9.29762C15.0598 9.29762 14.724 9.63341 14.724 10.0476H16.224ZM9.89062 10.0476C9.89062 9.63341 9.55484 9.29762 9.14062 9.29762C8.72641 9.29762 8.39062 9.63341 8.39062 10.0476H9.89062ZM23.1668 8.95667H1V10.4567H23.1668V8.95667ZM14.724 10.0476V11.4048H16.224V10.0476H14.724ZM14.724 11.4048C14.724 11.3558 14.7401 11.2919 14.7936 11.2308L15.9225 12.2185C16.1245 11.9877 16.224 11.6937 16.224 11.4048H14.724ZM14.7936 11.2308C14.8499 11.1664 14.9495 11.1072 15.0782 11.1072V12.6072C15.4169 12.6072 15.7177 12.4526 15.9225 12.2185L14.7936 11.2308ZM15.0782 11.1072H9.53646V12.6072H15.0782V11.1072ZM9.53646 11.1072C9.66516 11.1072 9.7647 11.1664 9.82099 11.2308L8.69213 12.2185C8.8969 12.4526 9.19779 12.6072 9.53646 12.6072V11.1072ZM9.82099 11.2308C9.8745 11.2919 9.89062 11.3558 9.89062 11.4048H8.39062C8.39062 11.6937 8.49016 11.9877 8.69213 12.2185L9.82099 11.2308ZM9.89062 11.4048V10.0476H8.39062V11.4048H9.89062Z"
            fill="white"
          />
        </svg>
      ),
      inventory: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M18 0H2C1 0 0 0.9 0 2V5.01C0 5.73 0.43 6.35 1 6.7V18C1 19.1 2.1 20 3 20H17C17.9 20 19 19.1 19 18V6.7C19.57 6.35 20 5.73 20 5.01V2C20 0.9 19 0 18 0ZM13 12H7V10H13V12ZM18 5H2V2L18 1.98V5Z"
            fill={fillColor}
          />
        </svg>
      ),
      profile: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="23"
          viewBox="0 0 20 23"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.4 6.95L9.4 0.2C9.75556 -0.0666667 10.2444 -0.0666667 10.6 0.2L19.6 6.95C19.8518 7.13885 20 7.43524 20 7.75V22.25H14.6429C14.7376 22.25 14.8284 22.2149 14.8954 22.1524C14.9624 22.0899 15 22.0051 15 21.9167C14.9985 20.6794 14.4712 19.4933 13.5339 18.6184C12.5965 17.7435 11.3256 17.2514 10 17.25C8.67438 17.2514 7.40349 17.7435 6.46614 18.6184C5.52878 19.4933 5.00151 20.6794 5 21.9167C5 22.0051 5.03763 22.0899 5.1046 22.1524C5.17158 22.2149 5.26242 22.25 5.35714 22.25H0V7.75C0 7.43524 0.148194 7.13885 0.4 6.95ZM12.5 13.5C12.5 14.8807 11.3807 16 10 16C8.61929 16 7.5 14.8807 7.5 13.5C7.5 12.1193 8.61929 11 10 11C11.3807 11 12.5 12.1193 12.5 13.5Z"
            fill={fillColor}
          />
        </svg>
      ),
    };

    return icons[name];
  };

  return (
    <div>
      {!isMobile && (
        <footer>
          <h3>&copy; Copyright Brevistay Hospitality Pvt. Ltd.</h3>
          <h5>
            For Support Mail us at{" "}
            <a href="mailto:hotels@brevistay.com" target="_top">
              hotels@brevistay.com
            </a>
          </h5>
        </footer>
      )}

      {isMobile &&
        !bottomTabFlag &&
        !bottomTabFlagFooter &&
        ![
          "/login",
          "/holida-inventory/bulk-update",
          "/create-room-category",
          "/internal-server-error",
        ].includes(props.history.location.pathname) &&
        !props.location.pathname.includes("/room-category") &&
        !props.location.pathname.includes("/rate-plan") && (
          <div className="mobile-footer">
            <Menu
              compact
              secondary
              pointing
              className="menu-footer"
              icon="labeled"
              fluid
              widths={4}
            >
              {["summary", "bookings", "inventory", "profile"].map((name) => (
                <Menu.Item
                  key={name}
                  name={name}
                  active={activeItem === name}
                  onClick={handleItemClick}
                  className="menu-item-footer"
                >
                  {renderSvgIcon(name)}
                  <p
                    className={`menu-text ${
                      activeItem === name
                        ? "colorFooter"
                        : "colorFooterDisabled"
                    }`}
                  >
                    {name.charAt(0).toUpperCase() + name.substring(1)}
                  </p>
                </Menu.Item>
              ))}
            </Menu>
          </div>
        )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  session: state.session.response,
});

export default connect(mapStateToProps)(withRouter(Footer));
